import { Component, Input } from '@angular/core';
import { FormatService } from '../../../services';
import { SummaryItem } from '../../../models';

@Component({
  selector: 'app-report-header-details',
  templateUrl: './report-header-details.component.html',
  styleUrl: './report-header-details.component.scss',
})
export class ReportHeaderDetailsComponent {
  @Input() addressTitle: string;
  @Input() address: string;
  @Input() addressee: string;
  @Input() additionalAddressTitle: string;
  @Input() additionalAddress: string;
  @Input() additionalAddressee: string;
  @Input() summaryItems: SummaryItem[];

  constructor(private formatService: FormatService) {}

  multiLineAddress(address: string): string {
    return this.formatService.multiLineToHtml(address);
  }
}
